import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d3e87be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-search" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "box-search" }
const _hoisted_4 = {
  key: 1,
  class: "section-list"
}
const _hoisted_5 = { class: "box-title" }
const _hoisted_6 = { class: "section-name" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "item-card" }

import { onMounted, reactive, ref } from 'vue';
  import { request } from '@/utils';
  import { Collection } from '@/stores';
  import { useRoute, useRouter } from 'vue-router';
  import _ from 'lodash';
  import { useI18n } from 'vue-i18n';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();
  const route = useRoute();
  const router = useRouter();
  const keyword = ref(String(route.query.keyword || ''));

  const breadcurmbRoutes = [
    {
      name: t('Home'),
      to: { name: 'home' }
    },
    {
      name: t('Search')
    }
  ];

  const store = reactive<Collection>(
    new Collection({
      params: {
        per_page: 9
      },
      fetch(params = {}) {
        // TODO: 对接全局搜索接口
        return request.get('/programs', { params });
      }
    })
  );

  const handleSearch = (keyword: string) => {
    store.resetData();
    router.replace({ query: { ...route.query, keyword } });
  };

  onMounted(
    () => store.fetchData({ ...store.params, ..._.pick(route.query, ['page', 'keyword']) })
  );

return (_ctx: any,_cache: any) => {
  const _component_AppBreadcurmb = _resolveComponent("AppBreadcurmb")!
  const _component_AppSearch = _resolveComponent("AppSearch")!
  const _component_AppEmptyView = _resolveComponent("AppEmptyView")!
  const _component_AppCardProgram = _resolveComponent("AppCardProgram")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AppBreadcurmb, { routes: breadcurmbRoutes }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_AppSearch, {
          modelValue: keyword.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
          onSearch: handleSearch
        }, null, 8, ["modelValue"])
      ]),
      (_unref(store).isEmpty)
        ? (_openBlock(), _createBlock(_component_AppEmptyView, {
            key: 0,
            text: _unref(t)('No search results'),
            mode: "search"
          }, null, 8, ["text"]))
        : (_unref(store).data.length)
          ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h4", _hoisted_6, _toDisplayString(_unref(t)('Program')), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).data, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "col-6 col-md-4"
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_AppCardProgram, {
                        sm: "",
                        program: item
                      }, null, 8, ["program"])
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
    ])
  ]))
}
}

})